module.exports = __webpack_public_path__ + "img/victron_100_50.bea73b1d.png";